import { Outlet } from "react-router-dom";
import SideBar from "../SideBar";
import Header from "../Header";
import Footer from "../Footer";
import { useState } from "react";

function AppTemplateLayout() {
  const [productIndex, setProductIndex] = useState(0);
  return (
    <div>
      <Header />
      {/* <SideBar /> */}
      <div>
        <Outlet context={[productIndex, setProductIndex]} />
      </div>
      <Footer />
    </div>
  );
}

export default AppTemplateLayout;
